// flow
import React from 'react'
import { Button } from 'reactstrap'
import { FlexColumn } from 'src/pages/_styles/container.styles'

type Props = {
	icon: React.ReactNode,
	color?: string,
	onClick: () => any,
	targetId?: string | number,
	disabled?: boolean,
	className?: string,
	dataToggle?: string,
	styles?: Object,
	type?: 'button' | 'submit' | 'reset',
}

const IconButton = ({
	color = 'default',
	icon,
	onClick,
	targetId,
	styles,
	disabled = false,
	className = '',
	dataToggle = undefined,
	type = 'submit',
	...rest
}: Props) => {
	const backgroundIsTransparent = color === 'transparent'

	return (
		<Button
			className={`btn-just-icon ${
				backgroundIsTransparent ? 'cm-button-transparent' : ''
			} ${className}`}
			data-testid='btn-just-icon'
			color={color}
			type={type}
			onClick={onClick}
			id={targetId || ''}
			disabled={disabled}
			data-toggle={dataToggle || undefined}
			style={{ ...styles }}
			{...rest}
		>
			<FlexColumn alignItems={'center'}>{icon}</FlexColumn>
		</Button>
	)
}

export default IconButton
